import { Box, Card, CardContent, CardHeader, Grid, IconButton } from "@mui/material";
import React, { useState } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import { MuiTooltip, ModalPopUp, NewFormSubmitButton } from "..";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Typography, useMediaQuery, useTheme, Button, Tooltip, Stack } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { timeoutCall } from "../common/timeout/timeoutcall";
import { ASSESSMENT_BASE_URL } from "../../utils/config";
// -------------------------------------------------------------------------------------

const useStyles = makeStyles((theme) => ({
  reponsive_textbox: {
    [theme.breakpoints.down("md")]: {
      width: "70vw !important",
      marginLeft: "15vw !important",
      overflow: "auto !important"
    },
    [theme.breakpoints.down("sm")]: {
      width: "90vw !important",
      marginLeft: "5vw !important",
      overflow: "auto !important"
    },
  },
}));

const CommonCrudPopup = ({
  bigScreen,
  mediumScreen,
  smallScreen,
  largeScreen,
  customWidth,
  heading,
  heading1,
  close,
  children,
  veryBigScreen,
  aiScreen,
  isDownload,
  downloadFunc,
  TARGET_URL,
  targetId,
  isUpload,
  upload,
  handleSubmit,
  handleSubmit1,
  handleSubmitSaveAs,
  hideSaveAndNext,
  alertSaveColor,
  alertDeleteColor,
  saveTextWidth,
  saveText,
  saveText1,
  loading,
  iconType,
  isViewClientAssessor,
  sendReminderEmailBySelection,
  clientAssessorsData,
  // added this two new prop for custom width and custom margin left whenever giving customWidth check and give the 
  // customMarginLeft and customMarginLeftWidth
  customMarginLeft,
  customMarginLeftWidth,
  ...props

  // Add new prop
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const [hoveredButton, setHoveredButton] = useState(null); // Tracks the hovered button
  const [focusedButton, setFocusedButton] = useState(null);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [disable, setDisable] = useState(false);
  const [isSave, setISave] = useState(false);
  const handleSave = async (save) => {
    const res = await handleSubmit();
    if (res) {
      setDisable(true);
      if (save) {
        timeoutCall(() => close?.());
      } else {
        timeoutCall(() => setDisable(false));
      }
    }
  };

  const handleSave1 = async (save) => {
    const res = await handleSubmit1();
    if (res) {
      setDisable(true);
      if (save) {
        timeoutCall(() => close?.());
      } else {
        timeoutCall(() => setDisable(false));
      }
    }
  };


  const handleSaveAs = async () => {
    const res = await handleSubmitSaveAs?.();

    if (res) {
      setDisable(true);

      timeoutCall(() => setDisable(false));
    }
  };
  const getButtonVariant = (buttonName) => {
    // A button is 'contained' if it's hovered or focused
    if (hoveredButton === buttonName || focusedButton === buttonName) {
      return "contained";
    }
    return "outlined";
  };

  // console.log(targetId)
  return (
    <ModalPopUp open={true}>
      <Card
        style={{
          width: largeScreen
            ? "72.5vw"
            : mediumScreen
              ? isSmallScreen ? "90vw" : "60vw"
              : smallScreen
                ? isSmallScreen ? "90vw" : "45vw"
                : customWidth || "76.5vw",
          marginTop: "16.5vh",
          // marginLeft: smallScreen ? "32vw" : mediumScreen ? "27vw" : "21vw",
          marginLeft: smallScreen ? isSmallScreen ? "5vw" : "32vw" : mediumScreen ? isSmallScreen ? "5vw" : "27vw" : customMarginLeft ? customMarginLeftWidth : "21vw",
          position: "relative",

          maxHeight: "85vh",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
        className="res_update_uc"
      >
        {(heading || close) && (
          <CardHeader
            title={
              heading && (
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                  sx={{ width: "100%", }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      textAlign: "center",
                      fontSize: "1.25rem",
                      fontWeight: 400,
                      ...(aiScreen && {
                        // backgroundColor: "cadetblue",
                        color: "white",
                      }),
                    }}
                  >
                    {heading}
                  </Typography>

                  {isViewClientAssessor && <Tooltip
                    arrow
                    placement="bottom-start"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: "#FFFFFF",
                          color: "#000000",
                          border: "1px solid #D9E2EC",
                          boxShadow: "0px 4px 12px rgba(0,0,0,0.12)",
                          maxWidth: 350,
                          p: 2,
                        },
                      },
                      arrow: {
                        sx: {
                          color: "#FFFFFF",
                        },
                      },
                    }}
                    title={
                      <>


                        <Typography variant="body2">
                          Displays unique clients and assessors from the selected assessments who have not completed their assessments and whose cut-off date has not passed. Users associated with multiple assessments are displayed only once.
                        </Typography>


                      </>
                    }
                  >
                    <InfoOutlinedIcon
                      color="primary"
                      sx={{
                        fontSize: 25,
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>}
                </Stack>

              )
            }
            action={
              close && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  {isUpload && (<MuiTooltip title="Upload Documents"> <IconButton aria-label="upload" onClick={upload}> {iconType === "folder" ? (<DriveFolderUploadIcon color="primary" />) :
                    (<AddCircleIcon color="primary" />)} </IconButton> </MuiTooltip>)}
                  {isDownload && (<MuiTooltip title="Download"> <IconButton aria-label="download" onClick={downloadFunc}> <CloudDownloadIcon /> </IconButton> </MuiTooltip>)}
                  {isViewClientAssessor && (<Button disabled={clientAssessorsData?.length > 0 ? false : true} variant="contained" color="primary" size="small" onClick={sendReminderEmailBySelection} > Send Reminder </Button>)}
                  <MuiTooltip title="Close"> <IconButton aria-label="close" onClick={close}> <CancelIcon color="red" /> </IconButton> </MuiTooltip>
                </Box>
              )
            }
            sx={{
              alignItems: "center", // Align title and actions
              "& .MuiCardHeader-content": {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: 40,
              },
            }}
          />
        )}

        {(heading1) && (
          <CardHeader
            title={
              heading1 && (
                <Typography
                  sx={{ fontSize: "1.25rem", backgroundColor: "#b9d6ee", paddingBottom: "0.25rem", paddingTop: "0.25rem", marginBottom: "2rem", textAlign: "center" }}
                >
                  {heading1}
                </Typography>
              )
            }
            sx={{
              paddingBottom: "0px!important",
            }}
          />
        )}

        <CardContent
          style={{
            maxHeight: "85vh", marginTop: "-2rem", overflowX: "hidden",
            overflowY: "auto",
          }}
        >
          {children}
        </CardContent>
        <footer>
          <Grid container className="create-pop-up-footer">
            <Grid item xs={12} sm={12} md={0.5} lg={0.5}></Grid>
            <Grid item xs={12} sm={12} md={11} lg={11}>
              <Box>
                {handleSubmit && (
                  <NewFormSubmitButton
                    variant={
                      hoveredButton || focusedButton ? "outlined" : "contained"
                    }
                    color={
                      alertSaveColor
                        ? "success"
                        : alertDeleteColor
                          ? "error"
                          : "primary"
                    }
                    //   loading={loading}
                    style={{ width: saveTextWidth ?? "6rem" }}
                    onClick={() => {
                      setISave(true);
                      handleSave(true);
                    }}
                    text={saveText ?? "Submit"}
                    loading={isSave && loading}
                    disabled={disable || loading}
                    className="create-pop-up-button-text"
                  />
                )}
                {(handleSubmit1 || handleSubmitSaveAs) &&
                  !Boolean(hideSaveAndNext) && (
                    <NewFormSubmitButton
                      variant={getButtonVariant("saveAndNext")}
                      onMouseEnter={() => setHoveredButton("saveAndNext")}
                      onMouseLeave={() => setHoveredButton(null)}
                      onFocus={() => setFocusedButton("saveAndNext")}
                      onBlur={() => setFocusedButton(null)}
                      color="primary"
                      // text="Save & New"
                      text={saveText1 ?? "Save & New"}
                      style={{ marginLeft: "1rem", width: "15rem" }}
                      onClick={() => {
                        setISave(false);
                        if (handleSubmitSaveAs) {
                          handleSaveAs?.(false);
                        } else {
                          handleSave1(true);
                        }
                      }}
                      loading={!isSave && loading}
                      disabled={disable || loading}
                      className="create-pop-up-button-text"
                    />
                  )}

              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={0.5} lg={0.5}></Grid>
          </Grid>
        </footer>
      </Card>
    </ModalPopUp >
  );
};

export default CommonCrudPopup;
